// AIConfirmationDialog.tsx
import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface AIConfirmationDialogProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onGenerate: () => void;
}

const AIConfirmationDialog: React.FC<AIConfirmationDialogProps> = ({
  open,
  title,
  description,
  onClose,
  onGenerate,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="ai-dialog-title"
      aria-describedby="ai-dialog-description"
    >
      <DialogTitle id="ai-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="ai-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onGenerate} color="primary" variant="contained">
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AIConfirmationDialog;